import { render } from "./MedicalReportButtons.vue?vue&type=template&id=33d28a73&scoped=true"
import script from "./MedicalReportButtons.vue?vue&type=script&lang=js"
export * from "./MedicalReportButtons.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d28a73"]])

export default __exports__